// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_Button_Primary_loader__z9JkG","rotate":"Loader_Button_Primary_rotate__XuDGc","prixClipFix":"Loader_Button_Primary_prixClipFix__N8qyB"};